import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';

import './index.css';
import './polyfills';
import App from './App';

const DEFAULT_CONFIG = {
	trackingId: 'UA-133283921-1',
	debug: true,
	gaOptions: {
		cookieDomain: 'none',
	},
};

if (process.env.NODE_ENV === 'production') {
	ReactGA.initialize(DEFAULT_CONFIG);
}

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js